export function StarIcon() {
  return (
    <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_10241_3268)">
        <path
          d="M7.0831 28.8089C7.70214 28.5709 9.28311 29.2168 10.4183 29.8387C10.0036 31.0216 9.27606 32.5032 8.66299 32.7386C6.30579 33.6389 3.8232 32.6968 3.3494 32.4971C3.56688 32.0233 4.7392 29.7048 7.0831 28.8089Z"
          fill="#B6E6FC"
        />
        <path
          d="M11.7513 29.8387C12.8868 29.2166 14.4645 28.5716 15.0865 28.8089C17.4306 29.7048 18.6018 32.0236 18.8202 32.4971C18.3467 32.6967 15.8651 33.6377 13.5066 32.7386C12.8935 32.5035 12.166 31.0217 11.7513 29.8387Z"
          fill="#B6E6FC"
        />
        <path
          d="M0.0520911 26.524C0.50561 26.2258 2.48134 25.0408 4.63584 25.4455C5.19139 25.549 6.07829 26.789 6.63263 27.7823C5.87418 28.0817 5.21282 28.5166 4.66616 28.9756C4.39921 29.0942 4.10695 29.2134 3.94064 29.1781C1.75954 28.7712 0.33263 26.9144 0.0520911 26.524Z"
          fill="#B6E6FC"
        />
        <path
          d="M17.5338 25.4434C19.7214 25.0343 21.7162 26.2558 22.1164 26.5186C21.7989 26.9615 20.3818 28.7757 18.2301 29.1771C18.0549 29.2125 17.7674 29.0932 17.5024 28.9746C16.9568 28.5155 16.3074 28.1001 15.5478 27.8007C16.1022 26.8073 16.9783 25.5476 17.5338 25.4434Z"
          fill="#B6E6FC"
        />
        <path
          d="M0.0315168 19.2873C0.593703 19.3849 2.549 19.8298 3.71107 21.4C3.99136 21.7784 3.89245 23.0788 3.63527 24.2284C2.63186 24.1663 1.33592 23.9357 1.03749 23.531C-0.151192 21.9254 -0.0205991 19.804 0.0315168 19.2873Z"
          fill="#B6E6FC"
        />
        <path
          d="M22.1327 19.2851C22.1914 19.8551 22.3074 21.9443 21.1332 23.531C20.835 23.9357 19.5389 24.1673 18.5354 24.2284C18.2782 23.0785 18.1791 21.7781 18.4596 21.4C19.6347 19.8114 21.623 19.374 22.1338 19.284L22.1327 19.2851Z"
          fill="#B6E6FC"
        />
        <path
          d="M2.06188 13.2677C2.53658 13.6193 4.05546 14.8801 4.42468 16.7772C4.52206 17.2741 3.82106 18.4226 3.1913 19.2375C2.33109 18.7353 1.28914 17.9582 1.19343 17.4638C0.817553 15.5356 1.78459 13.7358 2.06188 13.2677Z"
          fill="#B6E6FC"
        />
        <path
          d="M20.1034 13.2698C20.4083 13.7821 21.3466 15.5599 20.9751 17.4638C20.8792 17.9583 19.8375 18.7353 18.9772 19.2375C18.3475 18.4226 17.6466 17.2741 17.7439 16.7772C18.1119 14.8838 19.6273 13.6251 20.1034 13.2698Z"
          fill="#B6E6FC"
        />
        <path
          d="M14.5916 11.0034C15.125 11.1919 16.6207 11.8272 17.3692 13.2341C17.5377 13.5523 17.3154 14.5518 16.975 15.4377C16.0429 15.236 15.0597 14.8656 14.8916 14.5541C14.141 13.1438 14.4497 11.5514 14.5916 11.0034Z"
          fill="#B6E6FC"
        />
      </g>
      <path
        d="M21.7321 14.4756C21.8375 14.2471 22.1622 14.2471 22.2676 14.4756L24.4332 19.1706C24.4762 19.2638 24.5645 19.3279 24.6663 19.34L29.8008 19.9487C30.0507 19.9784 30.151 20.2872 29.9663 20.4581L26.1702 23.9686C26.0949 24.0382 26.0612 24.142 26.0812 24.2425L27.0889 29.3138C27.1379 29.5607 26.8752 29.7516 26.6556 29.6286L22.1439 27.1032C22.0544 27.0531 21.9453 27.0531 21.8558 27.1032L17.3441 29.6286C17.1245 29.7516 16.8618 29.5607 16.9108 29.3138L17.9185 24.2425C17.9385 24.142 17.9047 24.0382 17.8294 23.9686L14.0334 20.4581C13.8486 20.2872 13.949 19.9784 14.1989 19.9487L19.3334 19.34C19.4352 19.3279 19.5235 19.2638 19.5664 19.1706L21.7321 14.4756Z"
        fill="#00AFFF"
        stroke="#00AFFF"
        strokeWidth="1.10587"
      />
      <g clipPath="url(#clip1_10241_3268)">
        <path
          d="M28.9168 28.8081C29.5359 28.5702 31.1168 29.216 32.252 29.8379C31.8374 31.0208 31.1098 32.5024 30.4967 32.7378C28.1395 33.6381 25.6569 32.696 25.1831 32.4963C25.4006 32.0226 26.5729 29.704 28.9168 28.8081Z"
          fill="#B6E6FC"
        />
        <path
          d="M33.585 29.8379C34.7205 29.2159 36.2982 28.5708 36.9203 28.8081C39.2643 29.7041 40.4355 32.0229 40.654 32.4963C40.1805 32.6959 37.6988 33.637 35.3404 32.7378C34.7273 32.5028 33.9998 31.021 33.585 29.8379Z"
          fill="#B6E6FC"
        />
        <path
          d="M21.8858 26.5233C22.3394 26.225 24.3151 25.04 26.4696 25.4448C27.0251 25.5482 27.912 26.7882 28.4664 27.7816C27.7079 28.081 27.0466 28.5158 26.4999 28.9749C26.2329 29.0934 25.9407 29.2126 25.7744 29.1774C23.5933 28.7704 22.1664 26.9136 21.8858 26.5233Z"
          fill="#B6E6FC"
        />
        <path
          d="M39.3675 25.4426C41.5552 25.0336 43.5499 26.2551 43.9502 26.5179C43.6327 26.9607 42.2156 28.7749 40.0638 29.1763C39.8886 29.2118 39.6011 29.0924 39.3361 28.9738C38.7906 28.5147 38.1411 28.0994 37.3816 27.8C37.936 26.8065 38.8121 25.5468 39.3675 25.4426Z"
          fill="#B6E6FC"
        />
        <path
          d="M21.8653 19.2865C22.4274 19.3841 24.3827 19.8291 25.5448 21.3992C25.8251 21.7776 25.7262 23.078 25.469 24.2276C24.4656 24.1655 23.1697 23.9349 22.8712 23.5303C21.6825 21.9246 21.8131 19.8033 21.8653 19.2865Z"
          fill="#B6E6FC"
        />
        <path
          d="M43.9664 19.2844C44.0252 19.8543 44.1411 21.9435 42.9669 23.5303C42.6687 23.9349 41.3726 24.1666 40.3692 24.2276C40.1119 23.0778 40.0128 21.7773 40.2934 21.3992C41.4684 19.8106 43.4568 19.3733 43.9675 19.2833L43.9664 19.2844Z"
          fill="#B6E6FC"
        />
        <path
          d="M23.8956 13.2669C24.3703 13.6185 25.8892 14.8794 26.2584 16.7765C26.3558 17.2733 25.6548 18.4218 25.025 19.2367C24.1648 18.7345 23.1229 17.9575 23.0272 17.463C22.6513 15.5348 23.6183 13.735 23.8956 13.2669Z"
          fill="#B6E6FC"
        />
        <path
          d="M41.9371 13.2691C42.2421 13.7814 43.1803 15.5591 42.8088 17.463C42.713 17.9576 41.6712 18.7345 40.811 19.2367C40.1813 18.4219 39.4803 17.2734 39.5776 16.7765C39.9456 14.8831 41.461 13.6243 41.9371 13.2691Z"
          fill="#B6E6FC"
        />
        <path
          d="M29.4085 11.0005C29.5504 11.5451 29.8613 13.1408 29.1107 14.5534C28.9419 14.8704 27.9717 15.2352 27.0272 15.437C26.6857 14.551 26.4624 13.5527 26.632 13.2344C27.3903 11.8088 28.9147 11.1759 29.4085 11.0005Z"
          fill="#B6E6FC"
        />
      </g>
      <defs>
        <clipPath id="clip0_10241_3268">
          <rect width="11.0831" height="22.1663" fill="white" transform="translate(0 11)" />
        </clipPath>
        <clipPath id="clip1_10241_3268">
          <rect width="11.0831" height="22.1663" fill="white" transform="translate(32.917 11)" />
        </clipPath>
      </defs>
    </svg>
  );
}
